export const HOME = '/'
export const USER = '/user'
export const INTRODUCTION = '/introduction'
export const STORY_FINISHED = '/story-finished'
export const ACCOUNT = '/account'
export const SETTING = '/setting'
export const LOGIN = '/login'
// Auto-login landing page for links in our emails. Public: the whole point is that the reader
// is logged out. Kept short because it shows up in every email URL.
export const EMAIL_LINK_LOGIN = '/auth/e'
export const SIGNUP = '/signup'
// Public campaign landing page. No auth: paid traffic must see the price without a login.
export const OFFER = '/offer'
export const SCORECARD = '/scorecard'
// Give-get referral link a subscriber shares (/r/ABCD2345). Public: the friend has no account yet.
export const REFERRAL_LANDING = '/r/:code'
// Affiliate program application form (US$20 per paying subscriber, run in Referly). Public.
export const REFER = '/refer'
export const CHOOSE_LANGUAGE = '/choose-language'
export const LEAD_USER_PATH = '/:id/lead'
export const OLD_USER_PATH = '/:id/existing'
export const NEW_USER_PATH = '/:id/new'
export const WORD_RESULT = '/word-result'
export const NOT_FOUND = '/404'
export const STORY = '/story'
export const QUIZ = '/quiz'
export const QUESTION = '/question'
export const PAYMENT_SUCCESSFUL = '/payment-successful'
export const PAYMENT_FAILED = '/payment-failed'
export const DASHBOARD = '/dashboard'
// The old teacher dashboard, kept while the teacher desk settles in.
export const DASHBOARD_CLASSIC = '/dashboard/classic'
export const CREATE_MEET = '/dashboard/meeting'
export const LIVE_MEET = '/live'
export const PRO_MEET = '/pro'
export const CORRECTIONS = '/correction'
// A lesson's discussion on its own page, where the bell and the reply emails lead.
export const DISCUSSION = '/discussion'
export const TASTER = '/taster'
export const CLAIM_TRIAL = '/claim/trial'
export const CLAIM_OFFER = '/claim/offer'
export const CLAIM_TRIAL_OFFER = '/claim/trial-offer'
export const CLAIM_FREE_TRIAL = '/claim/free-trial'
export const HISTORY = '/history'
export const STORY_STREAKS = '/integrations/beeminder'
export const STORIES = '/stories'
export const WORDS = '/words'
export const EDITOR = '/dashboard/editor'
export const NORTHSTAR = '/dashboard/northstar'
export const CREATOR_PERFORMANCE = '/dashboard/creators'
// Translation review (staff, and freelance reviewers for their languages only).
export const TRANSLATIONS_REVIEW = '/dashboard/translations'
